import(/* webpackMode: "eager" */ "/vercel/path0/apps/terminal/app/ninxl/govts/page.tsx");
